import { Component } from 'react'
import Octicon, { CreditCard, ChevronDown, ChevronUp } from '@primer/octicons-react'
import { currencyFormatter, toNumber } from '../../utils/formatters'
import styles from '~/styles/ordersDetails.pricingDetails.module.css'

export default class PricingDetails extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}

	public constructor(props) {
		super(props)
		this.state = {
			isTableShown: false,
		}
	}

	public render(): JSX.Element | null {
		if (!this.props.order.ppnInterface) {
			return (
				<div 
					className={styles.main}
				>
					<div 
						className={styles.icon}
					>
						<Octicon icon={CreditCard} />
					</div>
					<div 
						className={styles.tableFrame}
					>
						<div 
							className={styles.labelFrame}
							onClick={this._onClick.bind(this)}
						>
							<div
								className={styles.label}
							>
								{this.props.t('Orders:Pricing details')}
							</div>
							<Octicon icon={this.state.isTableShown ? ChevronUp : ChevronDown} />
						</div>
						{this._getTable()}
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	private _getTable(): JSX.Element | null {
		if (this.state.isTableShown) {
			const trs = this._getTrs()
			let className = styles.table
			if (!this._hasDetails) {
				className += ' ' + styles.noDetails
			}
			return (
				<div 
					className={className}
				>
					<table>
						<thead/>
						<tbody>
							{trs}
						</tbody>
					</table>
				</div>
			)
		} else {
			return null
		}
	}

	private _getTrs() {
		const jsx = []
		jsx.push(this._getTr('Order Price'))
		jsx.push(this._getTr('Discount'))
		jsx.push(this._getTr('Package Price'))
		jsx.push(this._getTr('Delivery Price'))
		jsx.push(this._getTr('Total Price'))
		jsx.push(this._getTr('Delivery Cost'))
		jsx.push(this._getTr('Fuel included'))
		return jsx
	}

	private _getTr(key) {
		const label = this.props.t(key)
		let value
		let details
		let isSeparated = false
		if (key === 'Order Price') {
			value = toNumber(this.props.order.in_cost) + toNumber(this.props.order.discount_included)
		} else if (key === 'Discount') {
			value = 0 - toNumber(this.props.order.discount_included)
		} else if (key === 'Package Price') {
			if (this.props.order.packageName) {
				value = this.props.order.packagePrice
			}
		} else if (key === 'Delivery Price') {
			value = this.props.order.in_delivery_cost
			if (this.props.order.packageName) {
				details = this.props.t('(incl. pkg)')
			}
		} else if (key === 'Fuel included' && this.props.order.dealer_country === 'US') {
			value = this.props.order.fuel_surcharge
		} else if (key === 'Total Price') {
			value = this.props.order.in_total
		} else if (key === 'Delivery Cost') {
			value = this.props.order.in_delivery_cost_dealer
			isSeparated = true
		}
		if (details) {
			this._hasDetails = true
		}
		if (value) {
			const data = { 
				currency: this.props.order.currency,
				value: (+value).toFixed(2)
			}
			const valueString = currencyFormatter(data)
			return (
				<tr
					key={key}
					className={(isSeparated ? styles.shift : null)}
				>
					<td>
						{label}		
					</td>
					<td>
						{valueString}
					</td>
					<td>
						{details || null}
					</td>
				</tr>
			)
		}
	}

	private _onClick() {
		this.setState({ isTableShown: !this.state.isTableShown })
	}
}